import { Box, Typography } from '@mui/material'
import { footerLinksStyles } from 'src/view/layout/Footer'

const About = () => {
  return (
    <Box sx={footerLinksStyles.container}>
      <Typography variant="h3" sx={footerLinksStyles.heading}>
        About Proxio
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        Unbiased, agency-sourced reporting—made accessible.
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        Proxio is a media brand built to help audiences stay informed with clear, factual reporting grounded in the world's leading news agencies. We focus on speed, accuracy, and context—without partisan framing, sensationalism, or opinion-as-news.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        Our mission
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        Our mission is to deliver trustworthy news to a global audience by:
      </Typography>
      
      <ul>
        <li>Publishing fact-based reporting originating from reputable news agencies and verified primary sources</li>
        <li>Providing clear context so readers can understand what happened and why it matters</li>
        <li>Maintaining editorial independence with transparent standards for sourcing and corrections</li>
      </ul>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        What we publish
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        Proxio publishes agency-originated news reporting and updates, presented in formats designed for clarity and accessibility. We may publish brief context and explainers to help readers understand events, but we do not publish opinion pieces.
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        Proxio does not publish opinion journalism, endorsements, or political viewpoints.
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        Ownership and operator
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        This website (proxio.media) is owned and operated by:
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        <strong>Proxio, Ltd</strong><br />
        British Virgin Islands (BVI)
      </Typography>

      <Typography variant="h4" sx={footerLinksStyles.heading}>
        Editorial independence
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        Proxio's editorial decisions are made independently. Proxio does not accept payment in exchange for news coverage and does not run advertising on proxio.media.
      </Typography>
      
      <Typography sx={footerLinksStyles.paragraph}>
        <strong>Contact:</strong> contact@proxio.media
      </Typography>
    </Box>
  )
}

export default About